import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM24 20H13.748c.165-.64.252-1.31.252-2a7.98 7.98 0 0 0-2.708-6h7.585a4 4 0 0 1 3.88 3.03L24 20Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 18a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-2 .8v-1.6H5.063l2.068-2.069L6 14l-4 4 4 4 1.131-1.131L5.063 18.8H10Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }